// extracted by mini-css-extract-plugin
module.exports = {"root":"k3qcZveKOSTL5i7CuW6F"};